import DesignerSecondaryHub from "@/pages/disenador/DesignerSecondaryHub";
import { getDesignerLicenseHubCards } from "@/pages/disenador/designerHubSections";

export default function DesignerLicensesHub() {
  return (
    <DesignerSecondaryHub
      title="Licencias distribuidor y cartera"
      subtitle="Modelo distribuidor: tokens, registro, renovación, cartera e historial."
      breadcrumbSuffix="Licencias distribuidor y cartera"
      intro="Gestor de emisión y cartera de tokens emitidos. Distinto del ciclo SaaS en Centro de Licencias SaaS BNT (/platform)."
      cards={getDesignerLicenseHubCards()}
      testId="designer-licenses-hub"
    />
  );
}
